// userService.js
import { useEffect } from 'react';
import { API_CONFIG } from '../config'; 

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPINSTALLPUSH}`;

export const useTrackUser = () => {
  useEffect(() => {
    const trackNewUser = async () => {
      // Check if user has already been tracked in this browser session/storage
      if (!localStorage.getItem('tracked')) {
        const generatedId = 'USER-' + Math.random().toString(36).substring(2, 11).toUpperCase();
        
        try {
          const response = await fetch(CREATE_USER_ENDPOINT, {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json' 
            },
            body: JSON.stringify({ userId: generatedId })
          });

          const data = await response.json();

          if (response.ok && data.status === 'success') {
            localStorage.setItem('tracked', 'true');
            console.log("User Tracked Successfully:", generatedId);
          } else {
            console.error("Server tracking failed:", data.message || 'Unknown error');
          }
        } catch (error) {
          console.error("Network or parsing error during tracking:", error);
        }
      }
    };

    trackNewUser();
  }, []);
};